/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-24
 * @brief EHP 설비수명 - 설비수명Report 개발
 *
 ********************************************************************/
import React from "react";
/**
* @brief EHP 설비수명  - 설비수명Report 개발 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
function DeviceReportMain(props) {
    // props
    const setPopWin = props.setPopWin;
    const curTabMenu = props.curTabMenu;
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container", style: { "cursor": "default" } },
            React.createElement("div", { className: "area__error error-ready" },
                React.createElement("strong", null, "\uC11C\uBE44\uC2A4 \uC900\uBE44 \uC911 \uC785\uB2C8\uB2E4."),
                React.createElement("p", null, "LS ELCTRIC\uC758 ALO \uD50C\uB7AB\uD3FC\uACFC \uC5F0\uACC4\uD558\uC5EC \uC804\uB825\uC124\uBE44 \uC218\uBA85\uACFC \uAD00\uB828\uB41C Lifecycle \uBCF4\uACE0\uC11C\uB97C \uC81C\uACF5."),
                React.createElement("p", null, "(\u201923\uB144 \uC815\uC2DD \uC624\uD508 \uBC0F \uBE44\uC6A9 \uACF5\uC9C0 \uC608\uC815)")))));
}
export default DeviceReportMain;
